// ModalProvider.tsx
import { createContext, useContext, useState, ReactNode } from "react";
import Modal, { ModalParams } from "./Modal";

type ModalState = { content: ReactNode | null; open: boolean, params?: ModalParams };
type ModalCtx = { show: (c: ReactNode, params?: ModalParams) => void; hide: () => void };

const Ctx = createContext<ModalCtx | null>(null);

export function ModalProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ModalState>({ content: null, open: false });

  const show = (content: ReactNode, params?: ModalParams) => setState({ content, open: true, params: params });
  const hide = () => setState({ content: null, open: false });

  return (
    <Ctx.Provider value={{ show, hide }}>
      {children}
      <Modal open={state.open} onClose={hide} params={state.params}>
        {state.content}
      </Modal>
    </Ctx.Provider>
  );
}

export function useModal() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useModal must be used inside ModalProvider");
  return ctx;
}
